import { DomainSerializer } from 'src/app/global/serializables/domain.serializer';
import { ContratoComissao } from '../domain/contrato-comissao.model';

export class ContratoComissaoSerializer extends DomainSerializer<ContratoComissao> {}
